import React from "react";
import { YahooContent } from "../yahoo/YahooContent";
import { RollerAdsContent } from "../rollerads/RollerAdsContent";
import { useLanderConfig } from "../commons/ConfigContext";
import { FeedType } from "../types/LanderConfig";
import { isChinaTraffic } from "../commons/HelperFunctions";

interface AdContentProps {
  maxAds?: number;
  maxRS?: number;
  adIcon?: React.ReactNode;
  headerMessageId?: string;
}

export function AdContent({
  maxAds,
  maxRS,
  adIcon,
  headerMessageId,
}: AdContentProps) {
  const { landerConfig } = useLanderConfig();

  if (landerConfig.lander?.feedID === FeedType.ROLLER_ADS || isChinaTraffic()) {
    return <RollerAdsContent />;
  }

  return (
    <YahooContent
      maxAds={ maxAds }
      maxRS={ maxRS }
      adIcon={ adIcon }
      headerMessageId={ headerMessageId }
    />
  );
}
